import { SidebarComponent } from '../../components/sidebar/sidebar'
import { $el } from 'src/scripts/utils/utils'

const VIEWPORT_SELECTOR = '[data-product-information-drawer-viewport]'

export class ProductInformationDrawer extends SidebarComponent {
  mountComponent() {
    super.mountComponent()
    const viewport: HTMLFormElement = $el(VIEWPORT_SELECTOR, this.element)
    this.addListener(viewport, 'scroll', this.handleViewportScroll)
  }

  unmountComponent() {
    super.unmountComponent()
    const viewport: HTMLFormElement = $el(VIEWPORT_SELECTOR, this.element)
    this.removeListener(viewport, 'scroll', this.handleViewportScroll)
  }

  handleViewportScroll = (): void => {
    const viewport: HTMLFormElement = $el(VIEWPORT_SELECTOR, this.element)

    if (!viewport) {
      return
    }

    this.toggleAttribute('header-shadow-visible', viewport.scrollTop > 0)
  }
}
